import React from "react"
import { Tabs, Grid, Divider } from "@material-ui/core"
import { Redirect, useParams, Switch } from "react-router"
import { AreaHeader, Content, DisplayLimiter, NavLinkTab, PrivateRoute } from "../../components"
import { useQuerySettings } from "../../data"
import Overview from "./Overview"
// import Location from "./Location"
import Jobs from "./Jobs"
// import Groups from "./Groups"
import People from "./People"
import Training from "./Training"
import { useAuth } from "../../services"

const Reports = () => {
  const { page, days, locations, groups } = useParams()
  const { lang } = useQuerySettings()
  const { hasFeature } = useAuth()

  const filters = `/${days || 7}/${locations || "all"}/${groups || "all"}`

  const NavTab = ({ value }) => (
    <NavLinkTab label={getHeading(value)} base="/reports/" value={value} filters={filters} fullWidth={false} />
  )

  return (
    <DisplayLimiter>
      <AreaHeader title={lang.area.reports} titleIcon="reports" beta />

      <Content full start mb={5}>
        <Grid item xs>
          <Tabs
            variant="standard"
            value={page || "overview"}
            indicatorColor="primary"
            textColor="primary"
            aria-label="Select reporting area"
          >
            <NavTab value="overview" />
            {/* <NavTab value="locations" /> */}
            <NavTab value="jobs" />
            {/* <NavTab value="groups" /> */}
            <NavTab value="people" />
            {hasFeature("training") && <NavTab value="training" />}
          </Tabs>

          <Divider />

          <Switch>
            <PrivateRoute path="/reports/overview/:days/:locations/:groups" component={Overview} />
            {/* <PrivateRoute path="/reports/locations/:days/:locations/:groups" component={Location} /> */}
            <PrivateRoute path="/reports/jobs/:days/:locations/:groups/:process" component={Jobs} />
            <PrivateRoute path="/reports/jobs/:days/:locations/:groups" component={Jobs} />
            <PrivateRoute path="/reports/people/:days/:locations/:groups/:user" component={People} />
            <PrivateRoute path="/reports/people/:days/:locations/:groups" component={People} />

            {/* <PrivateRoute exact path="/reports/locations" component={Location} /> */}
            <PrivateRoute exact path="/reports/jobs" component={Jobs} />
            {/* <PrivateRoute exact path="/reports/groups" component={Groups} /> */}
            <PrivateRoute exact path="/reports/people" component={People} />

            <PrivateRoute
              exact
              path="/reports/training/:days/:locations/:groups"
              component={Training}
              feature="training"
            />

            <Redirect to="/reports/overview/7/all/all" />
          </Switch>
        </Grid>
      </Content>
    </DisplayLimiter>
  )
}

const getHeading = (page) => {
  switch (page) {
    case "overview":
      return "Overview"
    case "locations":
      return "Locations"
    case "jobs":
      return "Jobs"
    case "groups":
      return "Areas of work"
    case "people":
      return "People"
    case "training":
      return "Training"
    default:
      return "Loading..."
  }
}

export default Reports
